<mat-dialog-content class="d-flex flex-col">
    <div class="flex-row flex-space-between">
        <div>
            <mat-card-header class="p-0">
                <mat-card-title>
                    <h3 class="m-0" mat-dialog-title>Duplicate Album</h3>
                </mat-card-title>
            </mat-card-header>
        </div>
        <div class="float-end">
            <button (click)="this.dialogRef.close();" (keyup.enter)="this.dialogRef.close();" aria-label="Close window"
                    class="mat-dialog-close" mat-dialog-close mat-icon-button
                    matTooltip="Close Window">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <form class="pt-10">
        <app-timeline-multi-select (timelineSelect)="selectTimelines($event)"
                                   [filter]="{access:'write'}"
                                   [title]="'Duplicate to which Memory Boxes?'"></app-timeline-multi-select>

    </form>
</mat-dialog-content>
<mat-dialog-actions class="flex-space-around">
    <button (click)="this.dialogRef.close();" (keyup.enter)="this.dialogRef.close();" color="warn"
            mat-dialog-close
            mat-raised-button>
        Cancel
    </button>
    <button (click)="duplicate()" (keyup.enter)="duplicate()" [attr.aria-busy]="loading"
            [disabled]=" this.selectedTimelines.length < 1"
            color="primary" mat-raised-button>
        Duplicate
        @if (loading) {
            <mat-spinner [diameter]="24" aria-label="Duplicating" class="ms-2"></mat-spinner>
        }
    </button>
</mat-dialog-actions>

